<template lang="pug">
  .container-reg-3
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="success")
      el-step(title="完善商家资料", status="success")
      el-step(title="绑定联系方式", status="finish")
    c-header-small
      template(slot="left")
        h3 绑定联系方式
    el-form(:model="source", :label-position="labelPosition", label-width="125px", v-loading="loading").reg-form
      el-form-item(label="手机", required)
        .binding-container
          .display-block {{ source.resp_per_telephone_no || '未绑定' }}
          el-button(type="primary", @click="toSetPhone()")
            template(v-if="!source.resp_per_telephone_no") 绑定手机
            template(v-else) 修改手机
      el-form-item(label="邮箱")
        .binding-container
          .display-block {{ source.resp_per_email || '未绑定' }}
          el-button(type="primary", @click="toSetEmail()")
            template(v-if="!source.resp_per_email") 绑定邮箱
            template(v-else) 修改邮箱
    
      .reg-form-button-group
        //- el-button(type="primary", @click="back", :disabled="loading").reg-button 上一步
        el-button(type="primary", @click="save", :disabled="loading").reg-button 下一步

    verifier(ref="verifyEmail", @success_verify="toModifyEmail", scene="MODIFY_EMAIL", opt="MCH_VERIFY")
    verifier(ref="modifyEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-modify)
    verifier(ref="bindingEmail", @success_bind="modifyEmailSuccess", scene="MODIFY_EMAIL", opt="MCH_BINDING", method="email", is-binding)

    verifier(ref="verifyPhone", @success_verify="toModifyPhone", scene="MODIFY_MOBILE", opt="MCH_VERIFY")
    verifier(ref="modifyPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-modify)
    verifier(ref="bindingPhone", @success_bind="modifyPhoneSuccess", scene="MODIFY_MOBILE", opt="MCH_BINDING", method="phone", is-binding)
</template>

<script>
export default {
  data () {
    return {
      source:     {
        resp_per_telephone_no:  null,
        resp_per_email:         null,
      },
      biz_ticket:   null,
      loading:      false,

      isDesktop:  true,
    };
  },
  computed: {
    labelPosition () {
      return this.isDesktop ? 'right' : 'top';
    },
  },
  methods: {
    next () {
      this.$router.replace('/reg/done');
    },

    toSetEmail () {
      if (this.source.resp_per_email) {
        this.toModifyEmail();
      } else {
        this.toBindEmail();
      }
    },
    toBindEmail () {
      this.$refs.bindingEmail.init();
    },
    toModifyEmail (biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyEmail.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyEmail.init(biz_ticket);
      }
    },
    modifyEmailSuccess (resp_per_email) {
      this.source.resp_per_email = resp_per_email;
    },

    toSetPhone () {
      if (this.source.resp_per_telephone_no) {
        this.toModifyPhone();
      } else {
        this.toBindPhone();
      }
    },
    toBindPhone () {
      this.$refs.bindingPhone.init();
    },
    toModifyPhone (biz_ticket) {
      if (!biz_ticket) {
        this.$refs.verifyPhone.init();
      } else {
        this.biz_ticket = biz_ticket;
        this.$refs.modifyPhone.init(biz_ticket);
      }
    },
    modifyPhoneSuccess (resp_per_telephone_no) {
      this.source.resp_per_telephone_no = resp_per_telephone_no;
    },

    save () {
      if (!this.source.resp_per_telephone_no) {
        this.$message({
          type:     'warning',
          message:  `请绑定手机号码`,
        });
      } else {
        this.next();
      }
    },
  },
  mounted () {
    window.onresize = () => {
      this.isDesktop = window.screen.width >= 500;
    };
    window.onresize();
  }
};
</script>

